import { hiddenGems } from "@/mocks/anime";
import SectionHeading from "./SectionHeading";
import AnimeCard from "./AnimeCard";

export default function HiddenGems() {
  return (
    <section id="gems" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="冷门佳作"
            title="没多少人刷到，却值得跪着补完"
            desc="评分不输大热门、却被低估的宝藏番。它们或许宣传声量不大，但口碑与后劲都经得起二刷，适合想跳出片单舒适区的你。"
          />
          <a
            href="#subscribe"
            className="mb-10 hidden shrink-0 items-center gap-2 rounded-full border border-primary-200 px-4 py-2 text-sm font-medium text-primary-700 hover:bg-primary-50 transition-colors whitespace-nowrap md:inline-flex"
          >
            求小虎推荐更多
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {hiddenGems.map((item) => (
            <AnimeCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}